import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "background-editor" }
const _hoisted_2 = ["aria-label", "title", "onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconCancel = _resolveComponent("IconCancel")
  const _component_IconBlur = _resolveComponent("IconBlur")
  const _component_NcIconSvgWrapper = _resolveComponent("NcIconSvgWrapper")
  const _component_IconFolder = _resolveComponent("IconFolder")
  const _component_IconCheckBold = _resolveComponent("IconCheckBold")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      key: "clear",
      class: _normalizeClass(["background-editor__element", { 'background-editor__element--selected': $data.selectedBackground === 'none' }]),
      onClick: _cache[0] || (_cache[0] = $event => ($options.handleSelectBackground('none')))
    }, [
      _createVNode(_component_IconCancel, { size: 20 }),
      _createTextVNode(" " + _toDisplayString(// TRANSLATORS: "None" refers to "No background effect applied" in videos, for context, other options are "blur" or "image"
				$options.t('spreed', 'None')), 1)
    ], 2),
    _createElementVNode("button", {
      key: "blur",
      class: _normalizeClass(["background-editor__element", { 'background-editor__element--selected': $data.selectedBackground === 'blur' }]),
      onClick: _cache[1] || (_cache[1] = $event => ($options.handleSelectBackground('blur')))
    }, [
      _createVNode(_component_IconBlur, { size: 20 }),
      _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Blur')), 1)
    ], 2),
    ($setup.predefinedBackgrounds?.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          ($setup.canUploadBackgrounds)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("button", {
                  class: "background-editor__element",
                  onClick: _cache[2] || (_cache[2] = (...args) => ($options.clickImportInput && $options.clickImportInput(...args)))
                }, [
                  _createVNode(_component_NcIconSvgWrapper, {
                    svg: $setup.IconFileUpload,
                    size: 20,
                    inline: ""
                  }, null, 8, ["svg"]),
                  _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Upload')), 1)
                ]),
                _createElementVNode("button", {
                  class: _normalizeClass(["background-editor__element", { 'background-editor__element--selected': $options.isCustomBackground }]),
                  onClick: _cache[3] || (_cache[3] = (...args) => ($options.showFilePicker && $options.showFilePicker(...args)))
                }, [
                  _createVNode(_component_IconFolder, { size: 20 }),
                  _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Files')), 1)
                ], 2)
              ], 64))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.predefinedBackgroundsURLs, (path) => {
            return (_openBlock(), _createElementBlock("button", {
              key: path,
              "aria-label": $options.ariaLabelForPredefinedBackground(path),
              title: $options.ariaLabelForPredefinedBackground(path),
              class: _normalizeClass(["background-editor__element", { 'background-editor__element--selected': $data.selectedBackground === path }]),
              style: _normalizeStyle({
					'background-image': 'url(' + path + ')',
				}),
              onClick: $event => ($options.handleSelectBackground(path))
            }, [
              ($data.selectedBackground === path)
                ? (_openBlock(), _createBlock(_component_IconCheckBold, {
                    key: 0,
                    size: 40,
                    "fill-color": "#fff"
                  }))
                : _createCommentVNode("", true)
            ], 14, _hoisted_2))
          }), 128))
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      id: "custom-background-file",
      ref: "fileUploadInput",
      class: "hidden-visually",
      multiple: "",
      type: "file",
      tabindex: "-1",
      "aria-hidden": "true",
      onChange: _cache[4] || (_cache[4] = (...args) => ($options.handleFileInput && $options.handleFileInput(...args)))
    }, null, 544)
  ]))
}